import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import styles from './LightBoxHeader.css';


const LightBoxHeader = (props) => {
  const {
    close,
    deletePic,
    imageId,
    isDeleteAvailable,
  } = props;

  const onClickDeleteImage = useCallback(() => {
    deletePic(imageId);
  }, [deletePic, imageId]);

  return (
    <div className={styles.LightBoxHeader}>
      {isDeleteAvailable && (
        <DeleteForeverIcon
          className={styles.icon}
          onClick={onClickDeleteImage}
        />
      )}
      <CloseIcon
        className={styles.icon}
        onClick={close}
      />
    </div>
  );
};

LightBoxHeader.propTypes = {
  close: PropTypes.func.isRequired,
  deletePic: PropTypes.func,
  imageId: PropTypes.number,
  isDeleteAvailable: PropTypes.bool,
};

LightBoxHeader.defaultProps = {
  deletePic: () => undefined,
  imageId: undefined,
  isDeleteAvailable: false,
};

export default LightBoxHeader;
